import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 11.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0ZM10.5 18a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm20.092 18.72c.242-.116.304-.146.654-.333a21.931 21.931 0 0 0 3.53-2.367C36.602 32.507 39 29.945 39 26.607c0-1.437-.482-2.843-1.468-3.908C36.53 21.614 35.112 21 33.5 21c-1.258 0-2.379.641-3.095 1.144a9.957 9.957 0 0 0-.405.3 9.957 9.957 0 0 0-.405-.3C28.88 21.641 27.758 21 26.5 21c-1.611 0-3.03.614-4.032 1.699-.986 1.065-1.468 2.47-1.468 3.909 0 3.337 2.397 5.9 4.225 7.412a21.931 21.931 0 0 0 3.53 2.367c.311.167.63.32.949.475.099.047.197.09.296.138.29-.142.466-.22.592-.28ZM26.5 23c.646 0 1.372.367 2.021.835.6.432 1.133.95 1.479 1.347.346-.397.88-.915 1.479-1.347.65-.468 1.375-.835 2.021-.835 2.17 0 3.5 1.615 3.5 3.608 0 4.76-7 8.162-7 8.162s-7-3.403-7-8.163C23 24.616 24.33 23 26.5 23Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M33.04 7h-2.698L5.01 35h2.697L33.039 7Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramMortgageLowPercent40 = createIcon(IconComponent);